import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ContentTranslation, TranslationMessage } from '../models/content-translation.model';
import { UiLocaleService } from '../services/ui-locale.service';

@Pipe({
  name: 'contentTranslation',
  pure: false,
})
export class ContentTranslationPipe implements PipeTransform {
  constructor(private translate: TranslateService,
              private uiLocaleService: UiLocaleService) {
  }

  transform(source?: string | null,
            translation?: ContentTranslation | null,
            message?: TranslationMessage | null): string {
    const messageKey = message && message.messageKey && message.messageKey.trim();
    if (messageKey) {
      const translatedMessage = this.translate.instant(messageKey, message.messageParams || {});
      if (translatedMessage && translatedMessage.trim() && translatedMessage.trim() !== messageKey) {
        return translatedMessage;
      }
    }
    return this.uiLocaleService.resolveContent(source, translation);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/content-translation.pipe.ts